
<div class="landing vh-100" style="{{ '--landing-bg-cover: url('+currentImage+')'}}">

  <app-main-header></app-main-header>

  <section class="main-content mt-4 mb-5">
    <div class="container">
      <div class="row">

        @for (data of institutions; track data) {
          <div class="card-wrap col-md-4 animate__animated animate__fadeInUp">
            <div class="card cursor-pointer" routerLink="{{data?.link}}">
              <div class="card-bg" style="background-image: url({{data?.logo}});">
              </div>
              <div class="card-info">
                <h1 class="font-artistic">{{ data?.subTitle | translate }}</h1>
                <p>{{ data?.description}}</p>
              </div>
            </div>
          </div>
        }

      </div>
    </div>
  </section>

  <app-main-footer></app-main-footer>

</div>
